import React, { useState, useReducer, useEffect, useContext } from "react";
import { Modal, ModalBody } from "reactstrap";
import { CusButton } from "../../Components/From/Button";
import { Global } from "../../App";
import { FormattedMessage } from "react-intl";
import Tool_eachOtherQuiz from "../../Components/Tools/Tool_eachOtherQuiz";
import PerfectScrollbar from "react-perfect-scrollbar";
import cls from "classnames";

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case "UPDATE_STATE":
      payload.forEach((i) => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

function Tool__CusOtherNeed({
  needName = "",
  subArray = [],
  needType = "",
  needId,
  onClose,
  updateExtra,
  updateAddOrderExtra,
  refreshPage,
  setRefreshPage,
  sentOrder,
  isSentOrder,
  setIsOrderDisable,
  setIsSentOrder,
  setIsExtraCheck
}) {
  const [state, dispatch] = useReducer(reducer, {
    selected: pickDefaultTaste(),
  });
  const { globalState, dispatchGlobal } = useContext(Global);
  const [selectedValue, setSelectedValue] = useState("");
  const [multiSelectValue, setMultiSelectValue] = useState([]);
  const [disableValue, setDisableValue] = useState([]);
  const [selectedID, setSelectedID] = useState("");
  const [isdropdown, setIsdropdown] = useState(false);
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleSelection = (value) => {
    if (multiSelectValue.includes(value)) {
      setMultiSelectValue(multiSelectValue.filter((val) => val !== value));
    } else {
      setMultiSelectValue([...multiSelectValue, value]);
    }
  };
  const dropdownToggle = () => {
    setIsdropdown(!isdropdown);
  };

  function pickDefaultTaste() {}

  function loadSelected() {
    //比對資料有沒有在global裡
    if (
      globalState.customer.orderInfo.extraDataList &&
      globalState.ordermode != "addorder"
    ) {
      const matchingItems = subArray.filter((item) => {
        for (const globalItem of globalState.customer.orderInfo.extraDataList) {
          if (globalItem.selectedItemIDs.includes(item.id)) {
            return true;
          }
        }
        return false;
      });

      const matchingItemIDs = matchingItems.map((item) => item.id);

      if (matchingItems) {
        // console.log("matchingItemIDs", matchingItemIDs);
        setMultiSelectValue(matchingItemIDs);
        setSelectedID(matchingItemIDs[0]);
      }
    }

    if (globalState.ordermode == "addorder") {
      const filteredItems = subArray.filter((item) => item.selectedMode === 1);
      const addOrderSelectedIds = filteredItems.map((item) => item.id);

      if (addOrderSelectedIds) {
        setMultiSelectValue(addOrderSelectedIds);
        setSelectedID(addOrderSelectedIds[0]);
      }
    }
  }

  //顯示之前選擇的數值
  useEffect(() => {
    loadSelected();
  }, [globalState.langType]);

  useEffect(() => {
    const newDisableValue = [];

    subArray.forEach((item) => {
      if (multiSelectValue.includes(item.id)) {
        newDisableValue.push(...item.extraOptionExclude);
      }
    });

    setDisableValue([...new Set(newDisableValue)]);
  }, [multiSelectValue, subArray]);

  useEffect(()=>{
    try {
      if (globalState.ordermode === "addorder") {
        if (needType === 3 && multiSelectValue) {
          updateAddOrderExtra(multiSelectValue, needType, needId);
          setRefreshPage(!refreshPage);
        }

        if ((needType === 2 || needType === 1) && selectedID) {
          updateAddOrderExtra([selectedID], needType, needId);
        }
      } else {
        if (needType === 3 && multiSelectValue) {
          updateExtra(multiSelectValue, needType, needId);
        }

        if ((needType === 2 || needType === 1) && selectedID) {
          updateExtra([selectedID], needType, needId);
        }
      }
    } catch (error) {
    } 
  },[selectedID])

  return (
    <Modal isOpen fade={false} backdrop={false} onClose={onClose}>
      <div className="Tool Tool__CusSp d-flex justify-content-center align-items-center">
        <div className="Tool__CusSp__content d-flex flex-column h-75 justify-content-between p-5 position-relative min-h-400">
          <div className="d-flex flex-column position-absolute fixed-top p-4  my-2 h-100">
         {console.log("selectedID",selectedID)}
            <div className="Tool__CusSp__title">{needName}</div>
            <hr className="" />
            <div className="h-100 modal-scroll">
              {(() => {
                if (needType === 2) {
                  // 下拉選單
                  return (
                    <div className="w-100 h-100 align-items-center">
                      <div
                        className="w-100 text-center py-2 border_under "
                        onClick={dropdownToggle}
                      >
                        {/* 顯示選擇或是之前選的 */}
                        {(() => {
                          if (selectedValue) {
                            return (
                              <h3 className="txtColorBrown">{selectedValue}</h3>
                            );
                          }
                          if (selectedID) {
                            const selectedItem = subArray.find(
                              (finditem) => finditem.id === selectedID
                            ).langName;
                            return (
                              <h3 className="txtColorBrown">{selectedItem}</h3>
                            );
                          } else {
                            return (
                              <div className="w-100 d-flex justify-content-between px-3">
                                <h5>
                                  <FormattedMessage id="pages.staffCheckOrder.pleaseSelect" />
                                </h5>
                                <h5>▼</h5>
                              </div>
                            );
                          }
                        })()}
                      </div>
                      <div className="w-100 h-100 ">
                        {isdropdown ? (
                          <div className=" extra_dropdown">
                            {subArray.map((e, index) => (
                              <div
                                key={index}
                                className={
                                  selectedID == e.id ? "a-active" : "a"
                                }
                                onClick={() => {
                                  setSelectedValue(e.langName);
                                  setSelectedID(e.id);
                                  handleSelection(e.id);
                                }}
                              >
                                <span>{e.langName}</span>
                              </div>
                            ))}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                }
                if (needType === 3) {
                  // 多選
                  return (
                    // <div className="w-100 d-flex flex-wrap justify-content-between overflow-auto ">
                    <div className="w-100 d-flex flex-wrap justify-content-between modal-scroll pb-5">
                      {subArray.map((e, index) => {
                        const isSelected = multiSelectValue.includes(e.id);
                        const isDisabled = disableValue.includes(e.id);
                        const buttonClasses = `need_button w-45 ${
                          isSelected ? "need_button-on" : ""
                        } ${isDisabled ? "need_button-disable" : ""}`;

                        return (
                          <a
                            key={index}
                            className={buttonClasses}
                            disabled={isDisabled}
                            onClick={() => {
                              if (!isDisabled) {
                                handleSelection(e.id);
                              }
                            }}
                          >
                            {e.langName}
                          </a>
                        );
                      })}
                    </div>
                  );
                }
                if (needType === 1) {
                  return (
                    <div className="w-100 d-flex flex-wrap justify-content-between">
                      {subArray.map((e, index) => (
                        <a
                          key={index}
                          className={
                            selectedID == e.id
                              ? "need_button-on w-45"
                              : "need_button w-45"
                          }
                          onClick={() => {
                            setSelectedValue(e.langName);
                            setSelectedID(e.id);
                            handleSelection(e.id);
                          }}
                        >
                          {e.langName}
                        </a>
                      ))}
                    </div>
                  );
                  // return <Tool_trueFalseSelect subArray={subArray} />;
                }
              })()}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between m-0 p-4 position-absolute fixed-bottom bg-white">
            <div className="col-6 w-50 p-1">
              <CusButton.White
                children={<FormattedMessage id="popup.buttonBack" />}
                className="btn-block py-2"
                onClick={onClose}
              />
            </div>
            <div className="col-6  w-50 p-1">
              <CusButton.Red
                children={<FormattedMessage id="popup.buttonConfirm" />}
                className="btn-block py-2"
                onClick={async () => {
                  try {
                    if (globalState.ordermode === "addorder") {
                      if (needType === 3 && multiSelectValue) {
                        updateAddOrderExtra(multiSelectValue, needType, needId);
                        setRefreshPage(!refreshPage);
                      }

                      if ((needType === 2 || needType === 1) && selectedID) {
                        updateAddOrderExtra([selectedID], needType, needId);
                      }
                    } else {
                      // if (needType === 3 && multiSelectValue) {
                      //   updateExtra(multiSelectValue, needType, needId);
                      // }
                      if ((needType === 2 || needType === 1) && selectedID) {
                        updateExtra([selectedID], needType, needId);
                      }
                    }
                  } catch (error) {
                  } finally {
                    if (isSentOrder === true) {
                      await onClose();
                      await sentOrder();
                      setIsOrderDisable(false)
                    } else {
                      await onClose();
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default Tool__CusOtherNeed;
